(() => {
  const root = document.documentElement;
  const overlay = document.getElementById('cs-page-transition');
  const boot = window.CSPageTransitionBoot;
  if (!overlay || !boot || window.Shopify?.designMode || window.CSPageTransitions) return;
  const panel = overlay.querySelector('.cs-pt-panel');
  if (!panel || !window.CSS?.supports('animation-name', 'cs-pt-fade-in')) { boot.reset(); return; }
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let busy = false;
  let generation = 0;
  let rescue;
  let phaseTimer;
  const clearPending = () => { try { sessionStorage.removeItem(boot.key); } catch (_) {} };
  const reset = () => {
    generation++;
    busy = false;
    clearTimeout(rescue);
    clearTimeout(phaseTimer);
    clearTimeout(boot.timer);
    boot.reset();
  };
  const duration = () => motion.matches ? 60 : Math.min(450, Math.max(150, Number(overlay.dataset.duration) / 2 || 300));
  const show = () => {
    if (typeof overlay.showPopover === 'function') {
      try {
        overlay.setAttribute('popover', 'manual');
        if (!overlay.matches(':popover-open')) overlay.showPopover();
      } catch (_) { overlay.removeAttribute('popover'); }
    }
  };
  const animate = phase => new Promise(resolve => {
    let finished = false;
    const done = () => {
      if (finished) return;
      finished = true;
      clearTimeout(phaseTimer);
      panel.removeEventListener('animationend', end);
      resolve();
    };
    const end = event => { if (event.target === panel) done(); };
    panel.addEventListener('animationend', end);
    root.dataset.csPt = phase;
    phaseTimer = setTimeout(done, duration() + 100);
  });
  const excluded = 'form, button, input, select, textarea, summary, [role="button"], [role="tab"], [download], [data-no-transition], [data-cs-theme-toggle], .js-crime-bis, [data-crime-forms-close], #crime-forms-modal, .shopify-app-block, dialog, quick-add-component, variant-picker, predictive-search-component, facets-form-component, .facets, [data-no-navigation]';
  const destination = event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = event.target instanceof Element ? event.target : null;
    const link = target?.closest('a[href]');
    if (!link || target.closest(excluded) || link.isContentEditable) return;
    if (link.hasAttribute('onclick') || link.hasAttribute('aria-controls') || link.hasAttribute('data-action')) return;
    const action = target.closest('[on\\:click]');
    if (action && !String(action.getAttribute('on:click')).endsWith('/handleViewTransition')) return;
    const targetName = link.getAttribute('target') || document.querySelector('base[target]')?.getAttribute('target');
    if (targetName && targetName.toLowerCase() !== '_self') return;
    const raw = link.getAttribute('href')?.trim();
    if (!raw || raw.startsWith('#')) return;
    let url;
    try { url = new URL(link.href, location.href); } catch (_) { return; }
    if (url.origin !== location.origin || !/^https?:$/.test(url.protocol) || url.username || url.password) return;
    if (boot.clean(url.href) === boot.clean(location.href)) return;
    if (url.pathname === location.pathname) return;
    const routeRoot = overlay.dataset.routeRoot || '/';
    let path = url.pathname;
    if (routeRoot !== '/' && path.startsWith(routeRoot)) path = '/' + path.slice(routeRoot.length);
    if (!/^\/(?:$|products\/[^/]+\/?$|collections(?:\/[^/]+)?(?:\/products\/[^/]+)?\/?$|pages\/[^/]+\/?$|blogs(?:\/[^/]+){1,2}\/?$|policies\/[^/]+\/?$|search\/?$)/.test(path)) return;
    for (const key of url.searchParams.keys()) {
      if (/^(filter\.|sort_by$|section_id$|sections$|view$|preview_theme_id$)/.test(key)) return;
    }
    if (!overlay.showPopover && document.querySelector('dialog[open]')) return;
    return url;
  };
  window.addEventListener('click', async event => {
    const url = destination(event);
    if (!url || (motion.matches && overlay.dataset.reducedMotion === 'skip')) return;
    if (getComputedStyle(overlay).position !== 'fixed') return;
    event.preventDefault();
    if (busy) return;
    busy = true;
    clearTimeout(boot.timer);
    const run = ++generation;
    rescue = setTimeout(() => { clearPending(); reset(); }, 4500);
    try {
      show();
      await animate('cover');
      if (run !== generation) return;
      root.dataset.csPt = 'covered';
      try { sessionStorage.setItem(boot.key, JSON.stringify({ target: boot.clean(url.href), time: Date.now() })); } catch (_) {}
      location.assign(url.href);
    } catch (_) {
      clearPending(); reset(); location.assign(url.href);
    }
  });
  const enter = () => {
    if (root.dataset.csPt !== 'entry') { clearTimeout(boot.timer); return; }
    if (motion.matches && overlay.dataset.reducedMotion === 'skip') { reset(); return; }
    busy = true;
    show();
    const run = ++generation;
    requestAnimationFrame(() => requestAnimationFrame(async () => {
      if (run !== generation) return;
      await animate('reveal');
      if (run === generation) reset();
    }));
  };
  window.addEventListener('pageshow', event => { if (event.persisted) { clearPending(); reset(); } });
  window.addEventListener('pagehide', () => reset());
  window.addEventListener('keydown', event => { if (event.key === 'Escape' && busy) { clearPending(); reset(); } });
  window.CSPageTransitions = Object.freeze({ reset });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enter, { once: true });
  else enter();
})();
